import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import MOCK_DATA from './contractController.json';

const queryContractsInfo = (req, res, ctx) => {
  const responseData = MOCK_DATA['contractController/queryContractsInfo'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const contractsInfoAddCie = (req, res, ctx) => {
  const responseData = MOCK_DATA['contractController/contractsInfoAddCie'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(getApiEndpoint('contractController/queryContractsInfo'), withScenario(withAuthCheck(queryContractsInfo))),
  rest.post(getApiEndpoint('contractController/contractsInfoAddCie'), withScenario(withAuthCheck(contractsInfoAddCie))),
];
